import {
  useObjectApi,
  ObjectApiOptions,
  ObjectApiResult,
} from '~/libs/api-hooks/architect';

interface Organization {
  type: string;
  id: string;
  name: string;
  slug: string;
  projects: {
    total: number;
    totalWithBuilds: number;
    lastBuildFinishedAt: string | null;
  };
}

type UseOrganizationProps =
  | {
      orgId: string;
      orgSlug?: undefined;
      orgName?: undefined;
      vcsType?: undefined;
      reactQueryOptions?: ObjectApiOptions<Organization>;
    }
  | {
      orgId?: undefined;
      orgSlug?: undefined;
      orgName: string;
      vcsType: string;
      reactQueryOptions?: ObjectApiOptions<Organization>;
    }
  | {
      orgId?: undefined;
      orgSlug: string;
      orgName?: undefined;
      vcsType?: undefined;
      reactQueryOptions?: ObjectApiOptions<Organization>;
    };

/**
 * API hook to handle fetch requests to get orginzation details
 * @endpoint `/api/private/organization/{EncodedOrgNameOrOrgId}`
 * @service (TBC)
 */

const useOrganization = ({
  orgId,
  orgSlug,
  orgName,
  vcsType,
  reactQueryOptions,
}: UseOrganizationProps): ObjectApiResult<Organization> => {
  let pathname = '/api/private/organization/';
  const cacheKey = ['private', 'organization'];
  if (orgId) {
    cacheKey.push(orgId);
    pathname += orgId;
  } else if (orgSlug) {
    cacheKey.push(orgSlug);
    pathname += encodeURIComponent(orgSlug);
  } else if (vcsType && orgName) {
    cacheKey.push(`${vcsType}/${orgName}`);
    pathname += encodeURIComponent(`${vcsType}/${orgName}`);
  }

  return useObjectApi<Organization>({
    pathname,
    cacheKey,
    reactQueryOptions,
    includeApiKeyWhenAvailable: false,
  });
};

export default useOrganization;
